<nav mat-tab-nav-bar class="col mat-center-links">
  <a mat-tab-link
     [routerLink]="'priority'"
     routerLinkActive #rla3="routerLinkActive"
     [active]="rla3.isActive">
    Priority
  </a>
  <a mat-tab-link
     [routerLink]="'history'"
     routerLinkActive #rla2="routerLinkActive"
     [active]="rla2.isActive">
    History
  </a>
</nav>

<div class="main-content">
  <div class="container">
    <div class="row mb-4">
      <div class="col">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
